// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"TextSearch_SearchInput__1mo0_"};